<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="svg-container">
      <svg viewBox="0 0 144 144">
        <circle cx="72" cy="72" r="65" fill="none" />
      </svg>
      <span class="badge-number">{{ agedialogConfig.requiredAge }}</span>
    </div>
  </header>
  <!--todo langkey confirm_age_label</span>-->
  <p>Hiermit bestätige ich, dass ich {{agedialogConfig.requiredAge}} Jahre oder älter bin und diesen Artikel bestellen
    darf.</p>
  <footer class="buttons">
    <!--todo langkey <span langkey="confirm_age_yes">{{agedialogConfig.requiredAge}} </span> </span>-->
    <a class="btn action" (click)="confirm()"> <span>Ja, ich bin
        bereits<span class="age">{{agedialogConfig.requiredAge}}</span></span></a>
    <!--todo langkey <span langkey="confirm_age_no">{{agedialogConfig.requiredAge}} </span> </span>-->
    <a class="btn" (click)="cancel()"><span> Nein, ich bin noch
        nicht<span class="age">{{agedialogConfig.requiredAge}}</span></span></a>
  </footer>
</div>